import { $generateNodesFromDOM } from '@lexical/html';
import { MultilineElementTransformer } from '@lexical/markdown';
import { $isTableNode, TableCellNode, TableNode, TableRowNode } from '@lexical/table';
import { LexicalEditor, LexicalNode } from 'lexical';
import { cleanTableHTML } from '../../../utils/cleanTableHTML';
import { exportNodeToDOM } from '../../../utils/exportNodesToDOM';
import { isHtmlOrigin, markAsHtmlOrigin } from '../../../utils/tableOrigin';

export const createTableTransformer = (editor: LexicalEditor): MultilineElementTransformer => ({
  type: 'multiline-element',
  dependencies: [TableNode, TableCellNode, TableRowNode],

  regExpStart: /^<table(?:\s[^>]*)?>$/i,
  regExpEnd: /^<\/table>$/i,

  export: (node: LexicalNode) => {
    const isTable = $isTableNode(node);
    const htmlOrig = isTable ? isHtmlOrigin(node) : false;
    if (!isTable || !htmlOrig) {
      return null;
    }

    const element = exportNodeToDOM(node, editor);
    if (!element) {
      return null;
    }

    const container = document.createElement('div');
    container.appendChild(element);
    cleanTableHTML(container);

    return container.innerHTML;
  },

  replace: (parentNode, _children, startMatch, endMatch, linesInBetween) => {
    if (!startMatch || !endMatch || !linesInBetween) {
      return;
    }

    const tableHtml = [startMatch[0], ...linesInBetween, endMatch[0]].join('\n');
    const parser = new DOMParser();
    const doc = parser.parseFromString(tableHtml, 'text/html');
    const nodes = $generateNodesFromDOM(editor, doc);

    if (nodes.length === 0) {
      return;
    }

    nodes.forEach(node => {
      markAsHtmlOrigin(node);
      parentNode.append(node);
    });

    const lastNode = nodes[nodes.length - 1];
    if (lastNode) {
      lastNode.selectEnd();
    }
  },
});
